// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  
  // Update quantity selector visibility based on stock
  const quantitySelectorWrapper = document.querySelector('[data-quantity-selector-wrapper]');
  if (quantitySelectorWrapper && evt.detail.variant) {
    const hideWhenStockIsOne = quantitySelectorWrapper.dataset.hideWhenStockIsOne === 'true';
    
    if (hideWhenStockIsOne) {
      const inventoryJson = document.querySelector('[data-quantity-selector-inventory-json]');
      if (inventoryJson) {
        try {
          const inventoryData = JSON.parse(inventoryJson.textContent);
          const variantData = inventoryData.variants[evt.detail.variant.id];
          
          if (variantData) {
            const shouldHide = variantData.inventory_management !== null &&
                              variantData.inventory_policy === 'deny' &&
                              variantData.inventory_quantity === 1;
            
            if (shouldHide) {
              quantitySelectorWrapper.classList.add('hidden');
            } else {
              quantitySelectorWrapper.classList.remove('hidden');
            }
          }
        } catch (e) {
          console.error('Error parsing inventory data:', e);
        }
      }
    }
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// Desktop Swiper Initialization
// Theme only initializes Swiper for mobile. This adds desktop support.
// Scoped to .above-mobile carousels only (won't conflict with theme's mobile init)
(function() {
  const initializedDesktopSwipers = new WeakSet();
  
  function initDesktopSwiper(container) {
    console.log('[DesktopSwiper] Attempting init for:', container);
    console.log('[DesktopSwiper] Already in WeakSet?', initializedDesktopSwipers.has(container));
    console.log('[DesktopSwiper] Already has .swiper?', !!container.swiper);
    console.log('[DesktopSwiper] Has above-mobile class?', container.classList.contains('above-mobile'));
    
    // Skip if already initialized by us or theme
    if (initializedDesktopSwipers.has(container) || container.swiper) {
      console.log('[DesktopSwiper] Skipping - already initialized');
      return;
    }
    
    // Only initialize for desktop (above-mobile) carousels
    if (!container.classList.contains('above-mobile')) {
      console.log('[DesktopSwiper] Skipping - not above-mobile');
      return;
    }
    
    // Check if flu.chunks.swiper exists
    if (!window.flu?.chunks?.swiper) {
      console.error('[DesktopSwiper] window.flu.chunks.swiper not found - theme may not have loaded yet');
      return;
    }

    // Import Swiper chunk (same way theme does it)
    import(window.flu.chunks.swiper).then(({ Swiper }) => {
      console.log('[DesktopSwiper] Swiper loaded:', Swiper);
      
      // Skip if swiper was initialized while we were loading
      if (container.swiper) {
        console.log('[DesktopSwiper] Swiper already init during load, skipping');
        return;
      }
      
      const featuredSlide = container.querySelector('.carousel_slide[data-is-featured="true"]');
      const initialSlide = featuredSlide ? parseInt(featuredSlide.dataset.slideIndex) || 0 : 0;
      console.log('[DesktopSwiper] Initial slide:', initialSlide);
      
      const swiper = new Swiper(container, {
        slidesPerView: 1,
        spaceBetween: 4,
        grabCursor: true,
        watchSlidesProgress: true,
        loop: false,
        autoHeight: false,
        initialSlide: initialSlide
      });
      
      console.log('[DesktopSwiper] Swiper instance created:', swiper);
      console.log('[DesktopSwiper] container.swiper after init:', container.swiper);
      
      initializedDesktopSwipers.add(container);
      
      // Dispatch event for other scripts to hook into
      container.dispatchEvent(new CustomEvent('swiper:initialized', { detail: { swiper } }));
      console.log('[DesktopSwiper] Event dispatched');
    }).catch(err => {
      console.error('[DesktopSwiper] Error loading Swiper:', err);
    });
  }
  
  function initAllDesktopSwipers() {
    console.log('[DesktopSwiper] initAllDesktopSwipers called');
    // Find all desktop carousels that need Swiper
    const desktopCarousels = document.querySelectorAll('.product__media-container.above-mobile.carousel.swiper');
    console.log('[DesktopSwiper] Found desktop carousels:', desktopCarousels.length, desktopCarousels);
    desktopCarousels.forEach(initDesktopSwiper);
  }
  
  // Initialize after DOM ready
  function safeInit() {
    console.log('[DesktopSwiper] safeInit called');
    setTimeout(initAllDesktopSwipers, 300);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
  
  // Re-init on section load (theme editor)
  document.addEventListener('shopify:section:load', safeInit);
})();

// Thumbnails + Swipe sync (works for both mobile and desktop)
(function() {
  const syncedContainers = new WeakSet();
  
  function syncThumbnailsWithSwiper(swiperContainer) {
    console.log('[ThumbnailSync] Attempting sync for:', swiperContainer);
    if (syncedContainers.has(swiperContainer)) {
      console.log('[ThumbnailSync] Already synced, skipping');
      return;
    }
    
    // Find thumbnails
    let thumbnailsContainer = swiperContainer.nextElementSibling;
    console.log('[ThumbnailSync] Next sibling:', thumbnailsContainer);
    if (!thumbnailsContainer?.classList.contains('product-thumbnails')) {
      const productLeft = swiperContainer.closest('.product__primary-left');
      const isMobile = swiperContainer.classList.contains('below-mobile');
      console.log('[ThumbnailSync] Searching in productLeft, isMobile:', isMobile);
      thumbnailsContainer = productLeft?.querySelector(
        isMobile ? '.product-thumbnails:not(.above-mobile)' : '.product-thumbnails.above-mobile'
      );
    }
    console.log('[ThumbnailSync] Thumbnails container:', thumbnailsContainer);
    if (!thumbnailsContainer) {
      console.log('[ThumbnailSync] No thumbnails found, aborting');
      return;
    }
    
    const thumbnailButtons = thumbnailsContainer.querySelectorAll('[data-product-thumbnail]');
    if (!thumbnailButtons.length) return;
    
    const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide[data-media-item-id]'))
      .filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
    if (!slides.length) return;
    
    // Map media IDs to slide indices
    const mediaIdToIndex = {};
    slides.forEach((slide, i) => {
      if (slide.dataset.mediaItemId) mediaIdToIndex[slide.dataset.mediaItemId] = i;
    });
    
    function updateActiveThumbnail(mediaId) {
      thumbnailButtons.forEach(btn => {
        btn.classList.toggle('active', btn.dataset.thumbnailId === mediaId);
      });
    }
    
    function setupSync(swiper) {
      // Sync on slide change
      swiper.on('slideChange', function() {
        const idx = this.realIndex ?? this.activeIndex;
        const slide = slides[idx];
        if (slide?.dataset.mediaItemId) updateActiveThumbnail(slide.dataset.mediaItemId);
      });
      
      // Initial sync
      const idx = swiper.realIndex ?? swiper.activeIndex;
      if (slides[idx]?.dataset.mediaItemId) updateActiveThumbnail(slides[idx].dataset.mediaItemId);
      
      syncedContainers.add(swiperContainer);
    }
    
    // Thumbnail click handlers
    thumbnailButtons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const mediaId = this.dataset.thumbnailId;
        const slideIndex = mediaIdToIndex[mediaId];
        
        if (slideIndex !== undefined && swiperContainer.swiper) {
          const swiper = swiperContainer.swiper;
          swiper.params.loop ? swiper.slideToLoop(slideIndex, 300) : swiper.slideTo(slideIndex, 300);
        }
        updateActiveThumbnail(mediaId);
      });
    });
    
    // Wait for Swiper to be ready
    console.log('[ThumbnailSync] Checking if swiper ready:', !!swiperContainer.swiper);
    if (swiperContainer.swiper) {
      console.log('[ThumbnailSync] Swiper already ready, setting up sync');
      setupSync(swiperContainer.swiper);
    } else {
      console.log('[ThumbnailSync] Swiper not ready, waiting...');
      // Listen for our custom event or poll
      swiperContainer.addEventListener('swiper:initialized', (e) => {
        console.log('[ThumbnailSync] Got swiper:initialized event');
        setupSync(e.detail.swiper);
      }, { once: true });
      
      // Fallback: poll for theme's mobile swiper
      let attempts = 0;
      const poll = setInterval(() => {
        if (swiperContainer.swiper) {
          console.log('[ThumbnailSync] Found swiper via polling after', attempts, 'attempts');
          clearInterval(poll);
          setupSync(swiperContainer.swiper);
        } else if (++attempts > 50) {
          console.log('[ThumbnailSync] Gave up polling after 50 attempts');
          clearInterval(poll);
        }
      }, 100);
    }
  }
  
  function initThumbnailSync() {
    console.log('[ThumbnailSync] initThumbnailSync called');
    const containers = document.querySelectorAll('.product__media-container.carousel[data-thumbnails-swipe="true"]');
    console.log('[ThumbnailSync] Found containers:', containers.length, containers);
    containers.forEach(syncThumbnailsWithSwiper);
  }
  
  function safeInit() {
    setTimeout(initThumbnailSync, 500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }
  
  document.addEventListener('shopify:section:load', safeInit);
})();
